import { css } from '@emotion/core';

/* eslint-disable import/prefer-default-export */

export var badges = {
  name: "k008qs",
  styles: "display:flex;"
};